module.exports = __webpack_public_path__ + "static/media/saxeed.1b9627f9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/partners/saxeed.jpg
// module id = 1128
// module chunks = 4